module.exports = __webpack_public_path__ + "static/media/footerTopBg.f02c5427.webp";